module.exports = __webpack_public_path__ + "static/media/twitch.58025cb0.svg";